export type IconName =
  | "menu"
  | "subject"
  | "tests"
  | "build"
  | "variants"
  | "bank"
  | "statistics"
  | "profile"
  | "logout"
  | "clock";
const paths: Record<IconName, string> = {
  menu: "M4 6h16M4 12h16M4 18h16",
  subject:
    "M3 5h7a2 2 0 0 1 2 2v13a3 3 0 0 0-3-2H3V5Zm18 0h-7a2 2 0 0 0-2 2v13a3 3 0 0 1 3-2h6V5Z",
  tests: "M8 4h8v4H8V4ZM7 6H5v15h14V6h-2M8 12h8M8 16h5",
  build: "M4 5h16M4 12h16M4 19h16M8 3v4M16 10v4M10 17v4",
  variants: "M8 3h12v14H8V3ZM4 7v14h12M11 7h6M11 11h6",
  bank: "M4 3h16v18H4V3ZM8 3v18M11 8h6M11 13h6",
  statistics: "M4 20V4M4 20h17M9 16v-5M14 16V7M19 16V3",
  profile: "M16 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0ZM4 21v-2a8 8 0 0 1 16 0v2",
  logout: "M10 4H4v16h6M14 8l4 4-4 4M8 12h10",
  clock: "M12 8v5l3 2M9 2h6M12 2v3M21 13a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z",
};
export function NavIcon({ name }: { name: IconName }) {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d={paths[name]} />
    </svg>
  );
}
